module.exports = __webpack_public_path__ + "img/asan3.b438cf31.png";